import { put, takeEvery } from "redux-saga/effects";
import SearchEvents from "./SearchEvents";
import SearchApi from "./SearchApi";
import { search, searchComplete } from "./SearchActions";
import { SearchResult, ShowResult } from "./Search";

function* searchWorker({ userId, keywords }: ReturnType<typeof search>) {
    const result: SearchResult = yield SearchApi.search(userId, keywords);
    const showResult: ShowResult[] = searchResultConveter(result);
    yield put(searchComplete(showResult));
}

//検索結果を型変更
export const searchResultConveter = (result: SearchResult) => {
    const tempResultList: ShowResult[] = [];
    result &&
        result.documentList &&
        result.documentList.forEach((document) => {
            if(document.title){
                tempResultList.push({
                    id: document.documentId,
                    title: document.title,
                    thumbnails: document.thumbnails,
                    presenterId: document.presenterId,
                    presenterName: document.presenterName,
                    description: document.description,
                    documentType: document.description,
                    createDate: document.utime,
                    hitItem: document.hitItem,
                    tagList: document.tagList,
                    isVideo: false,
                });
            }
            
        });

    result &&
        result.videoList &&
        result.videoList.forEach((video) => {
            if(video.title){tempResultList.push({
                id: video.videoId,
                title: video.title,
                thumbnails: video.thumbnails,
                presenterId: video.presenterId,
                presenterName: video.presenterName,
                description: video.description,
                documentType: "",
                createDate: video.ctime,
                hitItem: video.hitItem,
                tagList: video.tagList,
                isVideo: true,
            });
            }
        });
    // 作成日降順で並び変える
    tempResultList.sort(
        (ShowResult1, ShowResult2) =>
            +new Date(ShowResult1.createDate) - +new Date(ShowResult2.createDate)
    );
    return tempResultList;
};
export default function* VideoSaga() {
    yield takeEvery(SearchEvents.SearchStarted, searchWorker);
}
